import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

// POAP
export const jaidenArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Jaiden/800/800_x800_Jaiden_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Jaiden/800/800_x800_Jaiden_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Jaiden/800/800_x800_Jaiden_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Jaiden/800/800_x800_Jaiden_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Jaiden/800/800_x800_Jaiden_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];

export const plasticPenArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Stefan/800/800_x800_Stefan_Artist_Media1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Stefan/800/800_x800_Stefan_Artist_Media2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Stefan/800/800_x800_Stefan_Artist_Media3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Stefan/800/800_x800_Stefan_Artist_Media4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Stefan/800/800_x800_Stefan_Artist_Media5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];

export const specterArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Specter/800/800_x800_Specter_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Specter/800/800_x800_Specter_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Specter/800/800_x800_Specter_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Specter/800/800_x800_Specter_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
];

export const fleckArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Thomas/800x800/800_x800_Thomas_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Thomas/800x800/800_x800_Thomas_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Thomas/800x800/800_x800_Thomas_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Thomas/800x800/800_x800_Thomas_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Thomas/800x800/800_x800_Thomas_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];

// ART

export const tudiscoArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Antoni/800/800_x800_Tudisco_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Antoni/800/800_x800_Tudisco_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Antoni/800/800_x800_Tudisco_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Antoni/800/800_x800_Tudisco_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Antoni/800/800_x800_Tudisco_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];

export const urliArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Bruno/800/800_x800_Brunp_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Bruno/800/800_x800_Brunp_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Bruno/800/800_x800_Brunp_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Bruno/800/800_x800_Brunp_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
];

export const charlotteArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/charlotte/800/800_x800_Charlotte_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/charlotte/800/800_x800_Charlotte_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/charlotte/800/800_x800_Charlotte_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/charlotte/800/800_x800_Charlotte_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/charlotte/800/800_x800_Charlotte_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];

export const authieArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Authie/800/800_x800_Anthony_Artist_Media_1.png",
    altText: "artist Media",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Authie/800/800_x800_Anthony_Artist_Media_2.png",
    altText: "artist Media",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Authie/800/800_x800_Anthony_Artist_Media_3.png",
    altText: "artist Media",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Authie/800/800_x800_Anthony_Artist_Media_4.png",
    altText: "artist Media",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/Authie/800/800_x800_Anthony_Artist_Media_5.png",
    altText: "artist Media",
    type: "img",
    key: 4,
  },
];
